// 主观题批阅
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool, utils_tool, component_tool } from '@/tool'

let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport } = component_tool;

class SubjectiveReview extends WizContainer {
  componentName = 'subjectiveReviewList';

  constructor(props) {
    super(props);

    this.state = {
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnInitCfg = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '考试名称',
        field: 'title',
      },
      {
        headerName: '考试分类',
        field: 'categoryType',
      },
      {
        headerName: '考试类型',
        field: 'examType',
      },
      {
        headerName: '开始时间',
        field: 'startDate',
      },
      {
        headerName: '结束时间',
        field: 'endDate',
      },
      {
        headerName: '状态',
        field: 'status',
      },
      {
        headerName: '已批阅数',
        field: 'reviewNum',
      },
      {
        headerName: '待批阅数',
        field: 'unreviewNum',
      },
    ]
    let exportColumns = columnInitCfg.map((e, i) => {
      if (i >= 1) {
        let colConfig = {
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        }
        e = { ...e, ...colConfig }
      }
      return e
    })
    if (o['success']) {
      let data = o['data']
      let statusArrString = ['草稿', '已发布', '已关闭']
      let examTypeArrString = ['独立考试', '课程考试']
      data && data.forEach(d => {
        d.status = statusArrString[d.status]
        d.examType = examTypeArrString[d.examType]
      })
      WizBrowserExport({
        title: '主观题批阅',
        sheetName: '主观题批阅',
        columns: exportColumns.filter((_, index) => index),
        rows: data,
        filename: '主观题批阅.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig(),
      apiDataFormat: {
        export: this._handleFile,
      }
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(SubjectiveReview);
